module.exports = __webpack_public_path__ + "static/media/CASETA.975e93f1.jpg";